import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Style
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/slidercaptcha.min.css'
import '@/assets/base.less' // global less

// Plugins
import RouterInterceptor from '@/plugins/router-interceptor'
import i18n from '@/plugins/i18n' // Internationalization
import ElementUI from 'element-ui'
import VueMoment from 'vue-moment'

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import VueClipboard from 'vue-clipboard2'
import Particles from 'particles.vue'

// configure language
locale.use(lang)
Vue.use(RouterInterceptor)
Vue.use(ElementUI)
Vue.use(VueMoment)
Vue.use(Particles)

Vue.config.productionTip = false
Vue.prototype.$confirm = ElementUI.MessageBox.confirm
Vue.prototype.$notify = ElementUI.Notification
Vue.use(VueClipboard)
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
